import { render, staticRenderFns } from "./SplitQuoteForm.vue?vue&type=template&id=70eaf94e&"
import script from "./SplitQuoteForm.vue?vue&type=script&lang=js&"
export * from "./SplitQuoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports